module.exports = __webpack_public_path__ + "static/media/graph_grey.86587fd8.png";